

export default {
  container: {
    display:"flex",
    flexDirection:"column",
    flex: 1,
    width: "100%",
  },
  row: {
    display:"flex",
    flexDirection: "row",
    alignItems: "flex-start",
    margin: "5px 0"
  },
  timeContainer: {
    flexBasis: "15%"
  },
  time: {
    fontSize: 11,
    color: "#888",
    fontStyle: "italic",
    textAlign: 'center'
  },
  iconContainer: {
    display:"flex",
    flexDirection:"column",
    flexBasis: "6%",
    alignItems: "center",
    alignSelf: "stretch",
    margin: "0 2%"
  },
  verticalLine: {
    flex: 1,
    width: 1,
    backgroundColor: "#ddd"
  },
  eventContainer: {
    display:"flex",
    flexDirection:"column",
    flexBasis: "75%",
    alignItems: "flex-start",
    backgroundColor: "#FFF",
    padding: 16,
    borderRadius: 15,
    shadowOffset: { width: -8, height: 0 },
    shadowColor: "#ccc",
    shadowOpacity: 0.2,
    marginBottom: 20,
    maxWidth:400,
    borderTopLeftRadius: 0,
    boxShadow:"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
  },
  icon: {
    textAlign: "center",
    width: 20,
    height: 20,
    backgroundColor: "#6F98FA",
    paddingTop:2.5,
    borderRadius: 10,
    color: '#e0e9ff',
    fontSize: 9,
    overflow: "hidden",
    border:"3px solid #e0e9ff"
  },
  title: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#666",
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20
  },
  description: {
    textAlign: "left",
    fontSize: 11,
    lineHeight: 18,
    paddingBottom: 10,
    color: '#999'
  }
}
